module.exports = __webpack_public_path__ + "static/media/06b_MLPS-2.3-EC-10_1.38fe2e14.svg";